/**
 * Audio player worklet (24kHz PCM playback).
 *
 * The processor is referenced with `new URL(..., import.meta.url)` so Vite
 * serves it in dev and emits it as a hashed asset in the build — the required
 * pattern for AudioWorklet modules (plain /public files cannot be imported).
 */
export async function startAudioPlayerWorklet(): Promise<[AudioWorkletNode, AudioContext]> {
  const audioContext = new AudioContext({ sampleRate: 24000 });

  const workletURL = new URL("./pcm-player-processor.js", import.meta.url);
  await audioContext.audioWorklet.addModule(workletURL);

  const audioPlayerNode = new AudioWorkletNode(audioContext, "pcm-player-processor");
  audioPlayerNode.connect(audioContext.destination);

  // audioPlayerNode.port is how PCM chunks are sent to the processor.
  return [audioPlayerNode, audioContext];
}
